/* tslint:disable */
/* eslint-disable */
/**
 * Yaway Workshop API
 * Yaway Workshop API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApiServiceInfo
 */
export interface ApiServiceInfo {
    /**
     * 
     * @type {number}
     * @memberof ApiServiceInfo
     */
    externalId: number;
    /**
     * 
     * @type {string}
     * @memberof ApiServiceInfo
     */
    name: string;
}

export function ApiServiceInfoFromJSON(json: any): ApiServiceInfo {
    return ApiServiceInfoFromJSONTyped(json, false);
}

export function ApiServiceInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiServiceInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'externalId': json['externalId'],
        'name': json['name'],
    };
}

export function ApiServiceInfoToJSON(value?: ApiServiceInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'externalId': value.externalId,
        'name': value.name,
    };
}

